import "../style.css";
import { Col, Row, Select } from "antd";
import { useCallback, useEffect, useState } from "react";
import dayjs from "dayjs";
import TemperatureAlertTable from "./TemperatureAlertTable";
import { getApis } from "../../Common/apis";
import {
  vehicleAlertListApiUrl,
  vehicleAlertsCountApiUrl,
} from "../../Common/endpoints";
import { useDispatch } from "react-redux";
import { setPageLastUpdatedTime, setPageLoader } from "../../../reducers/loaderSlice";

const TemperatureAlert = ({selectedTab}) => {
  const dispatch = useDispatch();
  const [alertsCount, setAlertsCount] = useState(null);
  const [alertTableData, setAlertTableData] = useState({
    List: [],
    totalElements: 0,
    loading: true,
  });
  const [filterTimeRange, setFilterTimeRange] = useState("1_m");
  const [paginationDetails, setPaginationDetails] = useState({
    current: 1,
    pageSize: 10,
  });
  const authToken = localStorage.getItem("authToken");

  const getAlertsCount = async (startTime, endTime) => {
    await getApis(
      vehicleAlertsCountApiUrl,
      {
        startTime: Math.floor(startTime),
        endTime: Math.floor(endTime),
      },
      authToken
    )
      .then((res) => {
        setAlertsCount(res?.data);
        dispatch(setPageLoader("live"));
        dispatch(setPageLastUpdatedTime(Date.now()));
      })
      .catch((e) => {
        console.log(e);
        dispatch(setPageLoader("live"));
      });
  };

  const getAlertList = useCallback(
    async (startTime, endTime) => {
      setAlertTableData((prev) => ({ ...prev, loading: true }));
      await getApis(
        vehicleAlertListApiUrl,
        {
          startTime: Math.floor(startTime),
          endTime: Math.floor(endTime),
          page: paginationDetails.current - 1,
          size: paginationDetails.pageSize,
        },
        authToken
      )
        .then((res) => {
          setAlertTableData({
            List: res?.data?.content,
            totalElements: res?.data?.totalElements,
            loading: false,
          });
        })
        .catch((e) => console.log(e));
    },
    [authToken, paginationDetails]
  );

  useEffect(() => {
    if (filterTimeRange && selectedTab === "temperatureAlert") {
      const filterType = filterTimeRange.split("_");
      const startTime = dayjs().subtract(filterType?.[0], filterType?.[1]);
      const endTime = dayjs();
      getAlertsCount(startTime, endTime);
      getAlertList(startTime, endTime);
      dispatch(setPageLoader("refresh"));

      const intervalId = setInterval(() => {
        dispatch(setPageLoader("refresh"));
        getAlertsCount(startTime, endTime);
        getAlertList(startTime, endTime);
      }, 60 * 1000);

      return () => clearInterval(intervalId);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getAlertList, filterTimeRange, selectedTab]);

  const updateTimeRange = (value) => {
    setFilterTimeRange(value);
    setPaginationDetails((prev) => ({ ...prev, current: 1 }));
  };

  const updatePaginationDetails = (value) => {
    setPaginationDetails(value);
  };

  return (
    <Row>
      <Col span={24}>
        <Row gutter={[16, 16]} className="flex-center">
          <Col xs={24} sm={24} md={24} lg={24} xl={6} className="head18">
            Battery Temperature
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={18}>
            <div className="float-right">
              <Select
                placeholder="Select a time range"
                data-testid="alert-timerange-dropdown"
                value={filterTimeRange}
                style={{ width: "200px" }}
                onChange={updateTimeRange}
              >
                <Select.Option value="1_m">last 1 min</Select.Option>
                <Select.Option value="5_m">last 5 mins</Select.Option>
                <Select.Option value="10_m">last 10 mins</Select.Option>
                <Select.Option value="30_m">last 30 mins</Select.Option>
                <Select.Option value="1_h">last 1 hour</Select.Option>
                <Select.Option value="6_h">last 6 hours</Select.Option>
                <Select.Option value="12_h">last 12 hours</Select.Option>
                <Select.Option value="24_h">last 24 hours</Select.Option>
              </Select>
            </div>
          </Col>
        </Row>

        <Row
          justify="space-around"
          align="middle"
          gutter={[16, 16]}
          className="mt2"
        >
          <Col
            flex={"center"}
            align={"center"}
            xs={24}
            sm={24}
            md={24}
            lg={24}
            xl={5}
          >
            <div className="alert-no-title"> Vehicles in Alert mode </div>
            <div className="mt2 alert-no"> {alertsCount} </div>
          </Col>
          <Col xs={24} sm={24} md={24} lg={24} xl={19}>
            <div className="shadow-card p0">
              <TemperatureAlertTable
                tableData={alertTableData}
                paginationDetails={paginationDetails}
                updatePaginationDetails={updatePaginationDetails}
              />
            </div>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default TemperatureAlert;
